// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TipTooltip extends Component {

  static Placement = {
    TOP: 'top',
    LEFT: 'left',
    RIGHT: 'right',
    BOTTOM: 'bottom'
  };

  static propTypes = {
    text: PropTypes.string.isRequired,

    placement: PropTypes.string
  };

  static defaultProps = {
    placement: TipTooltip.Placement.TOP
  };

  componentDidMount() {
    // -- bootstrap tooltip
    $('body').tooltip({
      selector: '[data-toggle="tooltip"]'
    });
  }

  render() {
    const className = this.props.className || "glyphicon glyphicon-question-sign"

    return (
      <sup className="tip_tooltip">
        <i
          className={className}
          data-toggle="tooltip"
          data-placement={this.props.placement}
          title={this.props.text}
        />
      </sup>
    );
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/components/TipTooltip.js